var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5654 14.0625V2.0625C12.5654 1.66468 12.4074 1.28314 12.1261 1.00184C11.8448 0.720535 11.4633 0.5625 11.0654 0.5625H3.56543C3.1676 0.5625 2.78607 0.720535 2.50477 1.00184C2.22346 1.28314 2.06543 1.66468 2.06543 2.0625V14.0625M12.5654 14.0625H14.0654M12.5654 14.0625H8.81543M2.06543 14.0625H0.56543M2.06543 14.0625H5.81543M8.81543 14.0625V10.3125C8.81543 10.1136 8.73641 9.92282 8.59576 9.78217C8.45511 9.64152 8.26434 9.5625 8.06543 9.5625H6.56543C6.36652 9.5625 6.17575 9.64152 6.0351 9.78217C5.89445 9.92282 5.81543 10.1136 5.81543 10.3125V14.0625M8.81543 14.0625H5.81543M5.06543 3.5625H5.81543M5.06543 6.5625H5.81543M8.81543 3.5625H9.56543M8.81543 6.5625H9.56543",
    stroke: "#6A7282",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalDetail);
export default __webpack_public_path__ + "static/media/HospitalDetail.031dba9a48637c58a097648e9eab3fb0.svg";
export { ForwardRef as ReactComponent };